import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { resolveVisitorState, saveSubscriber } from "./newsletter.server";

const subscribeSchema = z.object({
  email: z.string().trim().email().max(254),
  fullName: z.string().trim().max(120).optional().nullable(),
  stateCode: z.string().trim().length(2).optional().nullable(),
  pageUrl: z.string().max(500).optional(),
  userAgent: z.string().max(500).optional(),
  consentGranted: z.boolean().optional(),
});

export const detectVisitorState = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => z.object({ consentGranted: z.boolean() }).parse(data))
  .handler(async ({ data }) => {
    // IP-based geo detection only runs once the visitor has accepted cookies.
    if (!data.consentGranted) {
      return {
        stateCode: null,
        stateName: null,
        city: null,
        country: null,
        source: "no-consent" as const,
        confidence: "none" as const,
      };
    }
    return resolveVisitorState();
  });

export const subscribeToNewsletter = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => subscribeSchema.parse(data))
  .handler(async ({ data }) => {
    return saveSubscriber({
      email: data.email,
      fullName: data.fullName?.trim() || null,
      stateCode: data.stateCode ? data.stateCode.toUpperCase() : null,
      pageUrl: data.pageUrl,
      userAgent: data.userAgent,
      consentGranted: data.consentGranted ?? false,
    });
  });
